<script setup lang="ts">
// Material Symbols `business_center`, filled — the Portfolio nav glyph (matches investor-app tab bar). Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M4.0025 21.0006C3.4525 21.0006 2.98167 20.8048 2.59 20.4131C2.19833 20.0215 2.0025 19.5506 2.0025 19.0006V8.00063C2.0025 7.45063 2.19833 6.97979 2.59 6.58813C2.98167 6.19646 3.4525 6.00063 4.0025 6.00063H8.0025V4.00063C8.0025 3.45063 8.19833 2.97979 8.59 2.58813C8.98166 2.19646 9.4525 2.00062 10.0025 2.00062H14.0025C14.5525 2.00062 15.0233 2.19646 15.415 2.58813C15.8067 2.97979 16.0025 3.45063 16.0025 4.00063V6.00063H20.0025C20.5525 6.00063 21.0233 6.19646 21.415 6.58813C21.8067 6.97979 22.0025 7.45063 22.0025 8.00063V19.0006C22.0025 19.5506 21.8067 20.0215 21.415 20.4131C21.0233 20.8048 20.5525 21.0006 20.0025 21.0006H4.0025ZM10.0025 6.00063H14.0025V4.00063H10.0025V6.00063ZM20.0025 15.0006H15.0025V17.0006H9.0025V15.0006H4.0025V19.0006H20.0025V15.0006ZM11.0025 15.0006H13.0025V13.0006H11.0025V15.0006ZM4.0025 13.0006H9.0025V11.0006H15.0025V13.0006H20.0025V8.00063H4.0025V13.0006Z"
      fill="currentColor"
    />
  </svg>
</template>
